import React, { useState } from "react";
import { Link } from "react-router-dom";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    setError(null);
    setMessage(null);
    setSubmitting(true);

    try {
      const response = await fetch("/api/auth/forgot-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email.trim() }),
      });

      let data = {};
      try {
        data = await response.json();
      } catch {
        /* empty body */
      }

      if (!response.ok) {
        throw new Error(data.message || "Could not send reset link");
      }

      setMessage(
        "If this email is registered, a reset link has been sent. Please check your inbox."
      );
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-md w-full bg-white p-8 rounded-2xl shadow-xl">
        <div className="mb-6 flex flex-col items-center text-center">
          <img
            src="/logo.png"
            alt="WheelsERP Prime"
            className="h-16 w-16 object-contain"
          />
          <p className="mt-2 text-xs text-gray-500">Lotus</p>
          <p className="text-2xl font-semibold tracking-tight text-gray-900">
            WheelsERP <span className="italic text-blue-700">Prime</span>
          </p>
        </div>

        <h2 className="text-2xl font-bold mb-2 text-center">
          Forgot Password
        </h2>
        <p className="mb-6 text-center text-sm text-gray-500">
          Enter your registered email and we will send you a reset link.
        </p>

        {error && (
          <div className="mb-4 text-red-600 bg-red-100 p-2 rounded">
            {error}
          </div>
        )}

        {message && (
          <div className="mb-4 text-green-600 bg-green-100 p-2 rounded">
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            placeholder="Email address"
            className="w-full px-4 py-2 border rounded"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-blue-600 text-white py-2 rounded disabled:opacity-70"
          >
            {submitting ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        <p className="mt-4 text-center text-sm">
          <Link to="/login" className="text-blue-600 hover:underline">
            Back to login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
